const sectionFbPost03Css = `
[data-type='section-fb-post-03'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-fb-post-03'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-fb-post-03'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-fb-post-03'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 16px;
  margin-bottom: 30px;
}

[data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue h1,
[data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue h2,
[data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items {
  position: relative;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .list-post {
  padding: 16px 0;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item {
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.149);
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .author {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .author .author-avatar {
  position: relative;
  overflow: hidden;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .author .author-avatar img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .author .text-user .author-name {
  font-weight: bold;
  font-size: 16px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .author .text-user .created-at {
  font-size: 14px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .post-content .post-text {
  margin-bottom: 20px;
  padding: 0 16px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .post-content .wrap-img {
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .post-content .wrap-img img {
  display: block;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-state {
  padding: 16px 0;
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #a4b0be;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-state .wrap-reactions {
  display: flex;
  align-items: center;
  gap: 5px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-state .wrap-reactions .wrap-icon {
  display: flex;
  align-items: center;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-state .wrap-reactions .wrap-icon .icon-reaction svg {
  display: block;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-state .comment {
  display: flex;
  align-items: center;
  gap: 5px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-actions-disable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-actions-disable .item-action {
  display: flex;
  align-items: center;
  gap: 5px;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .wrap-item .wrap-actions-disable .item-action .icon-action svg {
  display: block;
  width: 16px;
  height: auto;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .swiper-button-next,
[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .swiper-button-prev {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #000000a1;
}

[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .swiper-button-next::after,
[data-type='section-fb-post-03'] .wrap-card .wrap-slider-post-items .swiper-button-prev::after {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

@container (max-width: 768px) {
  [data-type='section-fb-post-03'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-fb-post-03'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-fb-post-03'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue h1,
  [data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue h2,
  [data-type='section-fb-post-03'] [data-attribute='card-container'] .title-markqueue h3 {
    font-size: 20px;
    line-height: 24px;
  }
}
`;
export default sectionFbPost03Css;
